import { render, staticRenderFns } from "./ErrorListener.vue?vue&type=template&id=53bada5e"
import script from "./ErrorListener.vue?vue&type=script&lang=js"
export * from "./ErrorListener.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports